module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/big/2-7b5f62b7442e12f0d102522dc317da73.webp";